// extracted by mini-css-extract-plugin
export default {"header":"Header_header__b140w","appbar":"Header_appbar__pq2bH","toolbar":"Header_toolbar__hW1O9","body":"Header_body__dop0i"};